import { isAxiosError } from 'axios';

/**
 * creator-api answers with Nest error bodies: `message` is a string, or a
 * string[] for class-validator failures. Undefined when the shape is
 * anything else (network failure, HTML from a proxy).
 */
export const serverErrorMessage = (error: unknown): string | undefined => {
  if (!isAxiosError(error)) return undefined;
  const message: unknown = error.response?.data?.message;
  if (typeof message === 'string') return message;
  if (Array.isArray(message) && message.every((m) => typeof m === 'string')) {
    return message.join('. ');
  }
  return undefined;
};
